/**
 * CHARSTAN i18n Entry Point
 * M7B-P1: i18n Foundation
 * 
 * This file initializes i18n and re-exports for use in components.
 */

// Import and initialize i18n configuration
import i18n from './i18n/config';
import { SUPPORTED_LANGUAGES } from './i18n/config';

// Log initialization for debugging
console.log('[i18n] Initialized with language:', i18n.language);

// Re-export for use in components
export { SUPPORTED_LANGUAGES };
export default i18n;
